import { IResource } from '@gettactic/api';
import { useIsPrivacyEnabled } from '@gettactic/hooks';
import { useAuthenticated } from '@gettactic/hooks';
import React from 'react';
import { MapView } from './MapView';
import { useMapBuilderMappedResourcesData } from './hooks/useMapBuilderMappedResourcesData';
import {
  MapCurrentPosition,
  MapInteractiveZoneActionOptions,
  MapInteractiveZones
} from './types';

export interface NewMapViewProps {
  floor?: IResource;
  resources: IResource[];
  interactiveZoneInfo?: MapInteractiveZones;
  highlightResource?: (
    resId: string | null,
    options: MapInteractiveZoneActionOptions
  ) => void;
  mapEditPosition?: MapCurrentPosition | null;
  miniMapWidth?: number;
  miniMapHeight?: number;
  useSvg?: boolean;
  style?: React.SVGProps<SVGSVGElement>['style'];
}

export const MapBuilderViewer = React.forwardRef<
  SVGSVGElement | null,
  NewMapViewProps
>(
  (
    {
      floor,
      resources,
      interactiveZoneInfo,
      highlightResource,
      mapEditPosition,
      miniMapWidth,
      miniMapHeight,
      useSvg = false,
      style
    },
    ref
  ) => {
    const floorData = useMapBuilderMappedResourcesData(floor, resources);

    const {
      userContext: { authenticatedUser }
    } = useAuthenticated();

    const isPrivacyEnabled = useIsPrivacyEnabled();

    if (!floor) return null;

    return (
      <MapView
        value={floorData}
        initialPosition={mapEditPosition || undefined}
        interactiveZones={interactiveZoneInfo}
        highlightResource={highlightResource}
        key={floor?.id}
        authenticatedUser={authenticatedUser}
        isPrivacyMode={isPrivacyEnabled}
        miniMapWidth={miniMapWidth}
        miniMapHeight={miniMapHeight}
        useSVG={useSvg}
        ref={ref}
        style={style}
      />
    );
  }
);
